import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/_components/HeroFilm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/blog/BlogArchive.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/experience.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/chapters.css");
